import { Navigate, useLocation } from "react-router";
import { useAuth } from "../authentication/useAuth";
import { useEffect, useState } from "react";
import LoadingIndicator from "../loading/LoadingIndicator";
import { publicCustomerUserClient } from "../../api";

const AdminLoginOutlet = () => {
  const { onAdminLogin, user, authenticated } = useAuth();
  const location = useLocation();
  const [isProcessing, setIsProcessing] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processAdminLogin = async () => {
      try {
        // Pokud uz je uzivatel prihlaseny, neni co vymenovat.
        if (authenticated && user?.tenantCode && user?.customerId) {
          setIsProcessing(false);
          return;
        }

        // Cteme specialni sign-in token z query stringu
        const searchParams = new URLSearchParams(location.search);
        const tokenValue = searchParams.get("token");

        if (!tokenValue) {
          setError("Missing sign-in token in URL");
          setIsProcessing(false);
          return;
        }

        const exchangeKey = `signInAsExchange:${tokenValue}`;
        if (sessionStorage.getItem(exchangeKey) === "done") {
          setIsProcessing(false);
          return;
        }

        // Ochrana proti dvojimu provolani (napr. React StrictMode v devu).
        sessionStorage.setItem(exchangeKey, "done");

        // Dekodujeme URL-encoded token
        const signInAsToken = decodeURIComponent(tokenValue);

        // Vymenime specialni token za standardni login data
        const loginResult =
          await publicCustomerUserClient.exchangeSignInAsToken({
            token: signInAsToken,
          });

        // Validace dat
        if (!loginResult.success || !loginResult.customerUser) {
          setError("Invalid login result");
          setIsProcessing(false);
          return;
        }

        // Prihlasime uzivatele
        if (typeof onAdminLogin === "function") {
          await onAdminLogin(loginResult);
        } else {
          setError("Auth context not available");
        }
      } catch (err) {
        console.error("Admin login error:", err);
        if (!(authenticated && user?.tenantCode && user?.customerId)) {
          setError("Failed to process admin login");
        }
      } finally {
        setIsProcessing(false);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    processAdminLogin();
  }, [location.search, onAdminLogin, authenticated, user]);

  // Po uspesnem prihlaseni presmerujeme na homepage.
  if (user?.tenantCode && user?.customerId) {
    return <Navigate to={`/${user.tenantCode}/${user.customerId}`} replace />;
  }

  if (isProcessing) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <Navigate to="/404" replace />;
  }

  return null;
};

export default AdminLoginOutlet;
